export const props = Object.freeze({
  /**
   * The appointment days to display, each with its bookable slots. Object data has no attribute
   * form, so set it as a DOM property (`:entries.prop` in a template, `el.entries = …` in script);
   * a JSON string is accepted for markup that can only pass attributes.
   *
   * Each entry is `{ date, slots: [{ start_time, booking_url, visit_type_categories_description,
   * visit_type_categories }] }`, where `visit_type_categories` is an optional array of the visit
   * types the slot serves — `in-person`, `video` — and a slot listing `video` gets the video icon.
   *
   * @type {Array|String}
   * @default []
   */
  entries: {
    type: [Array, String],
    default: () => [],
  },
  /**
   * How many day cards to render. Any beyond this count are replaced by the Full Schedule
   * affordance.
   *
   * @type {Number}
   * @storybook-control number
   * @default 3
   */
  maxEntries: {
    type: Number,
    default: 3,
  },
  /**
   * `sp-button` variant for the individual slot times.
   *
   * @type {String}
   * @default "outlined"
   */
  slotVariant: {
    type: String,
    default: "outlined",
  },
  /**
   * `sp-button` variant for the per-card "show more slots" button.
   *
   * @type {String}
   * @default "outlined"
   */
  moreButtonVariant: {
    type: String,
    default: "outlined",
  },
  /**
   * Elevation passed to each day card. Omit for a flat card.
   *
   * @type {Number}
   * @storybook-control number
   * @default undefined
   */
  cardElevation: {
    type: Number,
    default: undefined,
    validator: (value) => [1, 2, 3].includes(value),
  },
  /**
   * Where the Full Schedule affordance sits relative to the cards. "inline" places it in the card
   * row; "bottom" puts it on its own line beneath them.
   *
   * @type {String}
   * @default "inline"
   */
  fullSchedulePlacement: {
    type: String,
    default: "inline",
    validator: (value) => ["inline", "bottom"].includes(value),
  },
  /**
   * Direction of the icon and text inside the Full Schedule affordance.
   *
   * @type {String}
   * @default "row"
   */
  fullScheduleDirection: {
    type: String,
    default: "row",
    validator: (value) => ["row", "column"].includes(value),
  },
});
